"use strict";Object.defineProperty(exports,"__esModule",{value:!0}),exports.default=function(){var e={};return e.promise=new Promise((function(r,t){e.resolve=r,e.reject=t})),e};
